import { useMutation } from 'react-query';
import { StaticTokens, TerminalServicesAPI } from '../../constants/API';
import axios from 'axios';

type TicketDataType = {
  topicId: number;
};

export const useGetTicket = (onSuccess?: () => void, terminalIp?: string | null) => {
  const resolvedToken =
    typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search).get('token') || StaticTokens.terminalToken
      : StaticTokens.terminalToken;
  const {
    mutate: getTicket,
    isLoading: isLoadingGetTicket,
    isError
  } = useMutation(
    ['getTicket'],
    (data: TicketDataType) =>
      axios.post(TerminalServicesAPI.getTicketInTerminal, data, {
        headers: {
          'X-API-TOKEN': resolvedToken
        }
      }),
    {
      onSuccess: (response) => {
        const itemId = response?.data?.itemId;
        if (itemId) {
          const printBody =
            terminalIp != null && terminalIp.trim() !== ''
              ? { terminalIp: terminalIp.trim() }
              : {};
          axios
            .post(
              TerminalServicesAPI.printTicketInTerminal(itemId),
              printBody,
              {
                headers: {
                  'X-API-TOKEN': resolvedToken,
                  'Content-Type': 'application/json'
                }
              }
            )
            .catch(() => {
              // print failures should not block ticket creation
            });
        }

        onSuccess?.();
      }
    }
  );

  return { getTicket, isLoadingGetTicket, isError };
};
